<div class="form-control">
  @if (additionalLabel) {
    <div class="form-control__additional-label">
      {{additionalLabel | translate}}
    </div>
  }
  <div class="form-control__input">
    <ng-content></ng-content>
    @if (label) {
      <span class="form-control__label" [ngClass]="{'filled': control?.value || control?.value === 0 || placeholder}">{{ label }}</span>
    }
  </div>
  @if (!control || (control && control.touched)) {
    @if (errorType() === 'tooltip') {
      @if (radioButton() && errors?.length) {
        <div class="form-control__error line"></div>
      }
      @for (error of errors; track $index) {
        <div class="form-control__error tooltip">
          <i class="icon-apply"></i>
          {{ error | translate }}
        </div>
      }
    }
    @if (errorType() === 'bottom') {
      @if (radioButton()) {
        <div class="form-control__error line"></div>
      }
      @for (error of errors; track $index) {
        <div class="form-control__error bottom">
          {{ error | translate }}
        </div>
      }
    }
  }
</div>
